import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=5338e30e&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=5338e30e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338e30e",
  null
  
)

export default component.exports